import { cx } from '@libs/classnames';
import styles from './GrandPrixMainSection.module.css';
import { ImportantText } from '@features/landing/shared/ui/components/ImportantText';
import { MainSection } from '@features/landing/shared/ui/sections/MainSection';

export function GrandPrixMainSection() {
  return (
    <MainSection
      title={<>Гран-при РШШ по&nbsp;блицу и&nbsp;рапиду</>}
      subtitle={<>Крупнейшая серия детских онлайн-турниров</>}
      details={
        <>
          <div className={cx(styles.detailsContent, styles.order1)}>
            <ImportantText preset="text-1">306&nbsp;турниров</ImportantText>{' '}
            за&nbsp;год,
            <br />
            каждые выходные,
            <br />
            с&nbsp;3&nbsp;января
          </div>
          <div className={cx(styles.detailsContent, styles.order2)}>
            <ImportantText preset="text-2">
              4&nbsp;200&nbsp;000&nbsp;₽
            </ImportantText>
            <br />
            призовой фонд
            <br />
            серии
          </div>
          <div className={cx(styles.detailsContent, styles.order3)}>
            Все турниры
            <br />
            <ImportantText preset="text-3">
              с&nbsp;обсчетом
              <br />
              рейтинга&nbsp;ФШР
            </ImportantText>
          </div>
        </>
      }
    />
  );
}
